import { useFeatures } from '../../../../../../shared/frontend/scripts/selectors/global';
import { FeatureFlag } from '../../../../../../shared/gameConfig/sharedTypes';

type TCurrentFeatures = Record<string, boolean> | undefined;

/**
 * Access rules for the talent categorization feedback loop. Kept as predicates over
 * the feature map (not hooks) so the legacy class-component nav can share them, and
 * so they stay in lockstep with the server-side checks in
 * `talentSemanticsFeedbackControllerFactory` — the one flag covers both seeing the
 * affordance and submitting.
 */
export function isTalentFeedbackEnabled(currentFeatures: TCurrentFeatures): boolean {
  return Boolean(currentFeatures?.[FeatureFlag.TALENT_SEMANTICS_FEEDBACK] || currentFeatures?.[FeatureFlag.ADMIN]);
}

/** Admins and the support team reach the backend without the dedicated flag. */
export function isTalentFeedbackAdminEnabled(currentFeatures: TCurrentFeatures): boolean {
  return Boolean(
    currentFeatures?.[FeatureFlag.ADMIN] ||
      currentFeatures?.[FeatureFlag.SUPPORT_TEAM] ||
      currentFeatures?.[FeatureFlag.TALENT_SEMANTICS_FEEDBACK_ADMIN]
  );
}

export function useTalentFeedbackEnabled(): boolean {
  return isTalentFeedbackEnabled(useFeatures());
}

export function useTalentFeedbackAdminEnabled(): boolean {
  return isTalentFeedbackAdminEnabled(useFeatures());
}
